<template>
    <div class="flex bg-white" style="height:500px;">
        <div class="flex items-center text-center lg:text-left px-8 md:px-12 lg:w-1/2">
            <div>
                <h2 class="text-3xl font-semibold text-gray-800 md:text-4xl">

                    <vue-typed-js :strings="['vos vacances', 'votre mariage', 'un anniversaire']" :loop="true"
                                  :backDelay="1500" :smartBackspace="true" @onComplete="doSmth()">
                        <h2>Une vidéo pour <span class="typing font-bold"></span> ?</h2>
                    </vue-typed-js>

                </h2>
                <p class="mt-2 text-sm text-gray-600 md:text-base">Lorem ipsum dolor sit amet, consectetur adipisicing
                    elit. Blanditiis commodi cum cupiditate ducimus, fugit harum id necessitatibus odio quam quasi,
                    quibusdam rem tempora voluptates. Cumque debitis dignissimos id quam vel!</p>
                <div class="flex justify-center lg:justify-start mt-6">
                    <a class="px-4 py-3 bg-blue-900 text-gray-200 text-xs font-semibold rounded hover:bg-blue-800"
                       href="#">Nous contactez</a>
                    <a class="mx-4 px-4 py-3 bg-gray-300 text-gray-900 text-xs font-semibold rounded hover:bg-gray-400"
                       href="#">Learn More</a>
                </div>
            </div>
        </div>
        <div class="hidden lg:flex lg:w-1/2 lg:h-full h-full" style="clip-path:polygon(10% 0, 100% 0%, 100% 100%, 0 100%)">
            <div class=" h-full  bg-fixed">

                <video autoplay muted loop disablePictureInPicture  id="myVideo">
                    <source src="../assets/video.mp4" type="video/mp4">
                </video>


            </div>
        </div>
    </div>
</template>

<script>

    import Vue from 'vue'
    import VueTypedJs from 'vue-typed-js'

    Vue.use(VueTypedJs)


    export default {
        name: "Hero",
        components: {

        }
    }
</script>

<style scoped>

</style>
